define('home/views/ActivityCardWrapperView',[
    'handlebars',
    'home/utils/layoutUtils',

    'home/views/common/ActivityCardView',
    'home/mixins/asCollapsibleCard',
    'home/mixins/withSubviews',

    'home/views/ActivityCardFavoriteView',
    'home/views/ActivityCardPostView',
    'home/views/ActivityCardReplyView',
    'home/views/ActivityCardTrendingView',
    'home/views/ActivityCardCreateView',

    'home/templates/activityCard',
], function (
    Handlebars,
    layoutUtils,

    ActivityCardView,
    asCollapsibleCard,
    withSubviews,

    ActivityCardFavoriteView,
    ActivityCardPostView,
    ActivityCardReplyView,
    ActivityCardTrendingView,
    ActivityCardCreateView,

    ActivityCardTemplate
) {
    'use strict';

    var parent = ActivityCardView;

    /**
     * The view for an activity card.
     * Handles rendering the card html structure, and updating the thread image when
     * necessary.
     * Delegates rendering the card content to the card views specific to the types
     * of activities: favorite, trending, post, reply
     */
    var ActivityCardWrapperView = parent.extend({
        className: function () {
            return 'card card-' + this.model.get('verb');
        },

        template: ActivityCardTemplate,

        templateHelpers: function () {
            return {
                canShowThreadImage: !layoutUtils.isNarrowLayout(),
                discussionRoute: this.model.thread.getDiscussionRoute(),
                image: this.model.thread.getImage(),
            };
        },

        initialize: function () {
            if (!layoutUtils.isNarrowLayout())
                this.listenTo(this.model.thread, 'change:content', this.renderThreadImage);

            this.contentRegion = this.addRegion('[data-role=card-content]');
        },

        /**
         * Returns a new view instance for the reason portion of this item's
         * card.
         * @returns {Backbone.View} - A view to show the reason for this item
         */
        getContentView: function () {
            var CardViewClass;

            switch (this.model.get('verb')) {
            case 'favorite':
                CardViewClass = ActivityCardFavoriteView;
                break;
            case 'post':
                CardViewClass = ActivityCardPostView;
                break;
            case 'reply':
                CardViewClass = ActivityCardReplyView;
                break;
            case 'trending':
                CardViewClass = ActivityCardTrendingView;
                break;
            case 'create':
                CardViewClass = ActivityCardCreateView;
                break;
            }

            return new CardViewClass({
                el: this.contentRegion.el,
                model: this.model,
            });
        },

        renderThreadImage: function () {
            if (layoutUtils.isNarrowLayout())
                return;

            var data = this.serializeData();
            data = this.mixinTemplateHelpers(data);
            this.$('[data-role=thread-image]').html(Handlebars.partials.threadImage(data));
        },

        onRender: function () {
            var contentRegion = this.contentRegion;
            this.activateRegion(contentRegion, this.getContentView);
            var contentView = contentRegion.currentView;

            if (contentView.shouldCollapse && contentView.shouldCollapse())
                this.$el.addClass('card-collapsed');
        },
    });


    var proto = ActivityCardWrapperView.prototype;
    asCollapsibleCard.call(proto);
    withSubviews.call(proto);

    return ActivityCardWrapperView;
});

